// Cookie utility functions
export const setSecureCookie = (name, value, options = {}) => {
  // Detect environment and set domain accordingly
  let domain = undefined;
  const hostname = window.location.hostname;

  if (hostname.endsWith('.brigiz.com')) {
    domain = '.brigiz.com'; // Production
  } else if (hostname.endsWith('.preprod-admin.brigiz.com')) {
    domain = '.preprod-admin.brigiz.com'; // Preprod
  } else if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    domain = undefined; // Local/dev, omit domain
  }

  const defaultOptions = {
    path: '/',
    domain: domain,
    secure: window.location.protocol === 'https:',
    sameSite: 'strict'
  };
  
  const cookieOptions = { ...defaultOptions, ...options };
  
  let cookieString = `${name}=${value}`;
  
  if (cookieOptions.path) {
    cookieString += `; path=${cookieOptions.path}`;
  }
  
  if (cookieOptions.domain) {
    cookieString += `; domain=${cookieOptions.domain}`;
  }
  
  if (cookieOptions.secure) {
    cookieString += '; secure';
  }
  
  if (cookieOptions.sameSite) {
    cookieString += `; samesite=${cookieOptions.sameSite}`;
  }
  
  if (cookieOptions.expires) {
    cookieString += `; expires=${cookieOptions.expires.toUTCString()}`;
  }
  
  document.cookie = cookieString;
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

export const deleteCookie = (name) => {
  let domain = undefined;
  const hostname = window.location.hostname;
  if (hostname.endsWith('.brigiz.com')) {
    domain = '.brigiz.com';
  } else if (hostname.endsWith('.preprod-admin.brigiz.com')) {
    domain = '.preprod-admin.brigiz.com';
  }
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;${domain ? ` domain=${domain};` : ''}`;
}; 